import React from 'react';
import ReactDOM from 'react-dom';

import Mails from './mails/Mails';

ReactDOM.render(
  <Mails />,
  document.getElementById('root')
);
